import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/user/line_back_ico_l.png'
import _imports_1 from '@/assets/user/cate1.png'
import _imports_2 from '@/assets/user/cate5.png'
import _imports_3 from '@/assets/user/cate2.png'
import _imports_4 from '@/assets/user/cate3.png'
import _imports_5 from '@/assets/user/cate4.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "BACK", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, " 스트레스 케어 ", -1)
const _hoisted_8 = { class: "stress_category" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, "전체", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: ""
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeaderLayout = _resolveComponent("HeaderLayout")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_GnbLayout = _resolveComponent("GnbLayout")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_HeaderLayout),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            type: "button",
            class: "in_back_btn",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.replace('/')))
          }, _hoisted_6),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_router_link, {
              to: "#",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showCategoryContents('0')))
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "#",
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showCategoryContents($setup.state.category[0].idx)))
            }, {
              default: _withCtx(() => [
                _hoisted_11,
                _createElementVNode("p", null, _toDisplayString($setup.state.category[0]?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "#",
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showCategoryContents($setup.state.category[1].idx)))
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _createElementVNode("p", null, _toDisplayString($setup.state.category[1]?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "#",
              onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showCategoryContents($setup.state.category[2].idx)))
            }, {
              default: _withCtx(() => [
                _hoisted_13,
                _createElementVNode("p", null, _toDisplayString($setup.state.category[2]?.name), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "#",
              onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showCategoryContents($setup.state.category[3].idx)))
            }, {
              default: _withCtx(() => [
                _hoisted_14,
                _createElementVNode("p", null, _toDisplayString($setup.state.category[3]?.name), 1)
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_GnbLayout),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      content: $setup.state.modalContent,
      onClose: $setup.modalClose
    }, null, 8, ["show", "content", "onClose"])
  ], 64))
}